const supportsNativeSmoothScroll =
  'scrollBehavior' in document.documentElement.style;

/* eslint-disable */
const smoothScrollTo = (to, duration) => {
  const element = document.scrollingElement || document.documentElement;
  const start = element.scrollTop;
  const change = to - start;
  const startDate = +new Date();

  // t = current time
  // b = start value
  // c = change in value
  // d = duration
  const easeInOutQuad = (t, b, c, d) => {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  };

  const animateScroll = _ => {
    const currentDate = +new Date();
    const currentTime = currentDate - startDate;
    element.scrollTop = parseInt(
      easeInOutQuad(currentTime, start, change, duration),
    );
    if (currentTime < duration) {
      requestAnimationFrame(animateScroll);
    } else {
      element.scrollTop = to;
    }
  };
  animateScroll();
};
/* eslint-enable */

function getPosition(element) {
  let el = element;
  let xPos = 0;
  let yPos = 0;

  while (el) {
    if (el.tagName === 'BODY') {
      // deal with browser quirks with body/window/document and page scroll
      const xScroll = el.scrollLeft || document.documentElement.scrollLeft;
      const yScroll = el.scrollTop || document.documentElement.scrollTop;

      xPos += el.offsetLeft - xScroll + el.clientLeft;
      yPos += el.offsetTop - yScroll + el.clientTop;
    } else {
      // for all other non-BODY elements
      xPos += el.offsetLeft - el.scrollLeft + el.clientLeft;
      yPos += el.offsetTop - el.scrollTop + el.clientTop;
    }

    el = el.offsetParent;
  }
  return {
    x: xPos,
    y: yPos,
  };
}

function getAnchorPosition(hash, offset) {
  const id = window.decodeURI(hash.slice(1));

  if (id !== '') {
    const anchorElement = document.getElementById(id);

    if (anchorElement) {
      return getPosition(anchorElement).y - offset;
    }
  }

  return null;
}

export function scrollToAnchor(hash = window.location.hash) {
  requestAnimationFrame(() => {
    window.scrollTo({
      top: 0,
    });
    const offset = getAnchorPosition(hash, 100);

    if (offset !== null) {
      if (supportsNativeSmoothScroll) {
        window.scrollTo({
          top: offset,
          behavior: 'smooth',
        });
      } else {
        console.log('IE11<3!');
        smoothScrollTo(offset, 600);
      }
    }
  });
}

function init() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      scrollToAnchor();
    });
  } else {
    scrollToAnchor();
  }

  window.addEventListener('hashchange', () => {
    scrollToAnchor();
  });
}

export default init();
